<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-copy-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <h5 class="title" :class="{'webshare' : mode == 1}"></h5>
                <div class="dialog-body">
                    <div class="share-text">{{ text }}</div>
                </div>

                <button class="u-btn copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt" @click="copy" v-if="!ajax_error"></button>   
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            iscopy : false,
            text : '请稍后……',
            shareTxt : '分享专属链接 开启助力',
            gid : '',
            mode : 1,
            ajax_error : false,           
        }
    },
    created (){
        this.render();
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              _this.$toast("复制成功");
              _this.text = '链接复制成功，快去邀请吧！';
              _this.iscopy = true;
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },
        render() {
            var _this = this;
            var key = this.mode == 1 ? 'share' : 'code';
            this.$axios.get(ajax_url_map.invite,{
                params : {
                    mode : this.mode,
                    key : key,
                }
            })
            .then(res => {
                console.log(res);
                _this.shareTxt = _this.text = res.data.koudai ? (res.data.koudai + res.data.url) : ('分享专属链接 召回你的老友' + ( res.data.url || (_this.$global.domain + '?code=' + res.data.inviteCode)  ))
               //_this.shareTxt = res.data.koudai ? (res.data.koudai + (_this.$global.domain + '?code=' + res.data.code) ) : ('分享专属链接 召回你的老友' + ( res.data.url || (_this.$global.domain + '?code=' + res.data.inviteCode)  ))
            },rej => {
                let text = rej.code == 1005 && this.mode == 2 ? '招募失败，招募者需等级≥11' : rej.message;
                this.ajax_error = true;
                //_this.$toast(text)
                _this.text = text
            });
        },       
    },
}
</script>

<style scoped>
/* share */
.m-copy-modal {
    position: relative;
    width: 629px;
    height: 329px;
    font-size: 22px;
    color: #47505a;
    background-image: url(~@/assets/images/modal/bg-modal-copy.png);
}

.title{
    width: 516px;
    height: 55px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/modal/title-copy.png);    
}

.title.webshare{
    width: 516px;
    height: 55px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/modal/title-webshare.png);    
}

.dialog-wrapper{
    /* padding: 0 20px 0; */
}

.m-share-modal h6 {
    /* height: 14px; */
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 15px;
}

.m-copy-modal .share-text {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50px;    
    padding: 15px 68px 0;
    word-break: break-all;
    font-size: 22px;
    color: #47505a;
}

.u-btn.copy {
    position: absolute;
    left: 50%;
    bottom: 15px;
    width: 239px;
    height: 84px;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/modal/btn-copy.png);
}

</style>




// WEBPACK FOOTER //
// src/components/CopyModal/copyModal.vue